// extracted by mini-css-extract-plugin
export var logo = "footer-module--logo--RYuWs";